import axiosInstance from "@/app/api";
import {
  ManageBookingResponse,
  TripRatingItem,
  TripRatingResponse
} from "@/types/booking";

const tripRatingSampleRows = [
  {
    id: 1,
    name: "Arun Kumar",
    tripInfo: "/images/avatar.png",
    time: 1778137200000,
    vehicleName: "TN01A9934",
    routeName: "Route-04",
    rating: 4,
    description: "Bus arrived on time and the ride was smooth throughout.",
    filePath: "/images/avatar.png"
  },
  {
    id: 2,
    name: "Priya Sharma",
    tripInfo: "/images/avatar.png",
    time: 1778140800000,
    vehicleName: "TN38 DE 2312",
    routeName: "Route-07",
    rating: 5,
    description: "Very clean vehicle and the staff handled boarding well.",
    filePath: "/images/avatar.png"
  },
  {
    id: 3,
    name: "Rohit S",
    tripInfo: "/images/avatar.png",
    time: 1778144400000,
    vehicleName: "TN66 BY 2295",
    routeName: "Route-12",
    rating: 3,
    description: "Trip was okay, but pickup was a few minutes late.",
    filePath: ""
  },
  {
    id: 4,
    name: "Nivetha R",
    tripInfo: "/images/avatar.png",
    time: 1778148000000,
    vehicleName: "TN09 Z 4455",
    routeName: "Route-03",
    rating: 4,
    description: "Comfortable trip and the driver was courteous.",
    filePath: "/images/avatar.png"
  }
];

const tripRatingFallbackMeta: Meta = {
  totalRecords: tripRatingSampleRows.length,
  currentPage: 1,
  pageSize: tripRatingSampleRows.length,
  totalPages: 1
};

const manageBooking = async (request: any): Promise<ManageBookingResponse> => {
  return await axiosInstance()
    .post("/api/v2/manage/bookings", request)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<ManageBookingResponse> = response.data;
        if (neoresponse && neoresponse.data) {
          return neoresponse.data;
        }
        return {} as ManageBookingResponse;
      }
      return {} as ManageBookingResponse;
    })
    .catch((error: any) => {
      return {} as ManageBookingResponse;
    });
};

const tripRating = async (): Promise<TableResponse<TripRatingItem>> => {
  return await axiosInstance()
    .get("/api/v2/trip/rating/list")
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<TripRatingResponse> = response.data;
        const row = neoresponse?.data?.ratingList?.map(row => ({
          ...row
        }));
        const rows: TripRatingItem[] =
          row && row.length > 0 ? row : tripRatingSampleRows;
        return {
          rows,
          meta: neoresponse?.meta
        };
      }
      return {
        rows: tripRatingSampleRows,
        meta: tripRatingFallbackMeta
      };
    })
    .catch((error: any) => {
      return {
        rows: tripRatingSampleRows,
        meta: tripRatingFallbackMeta
      };
    });
};

export const bookingService = {
  manageBooking,
  tripRating
};
